import React, { PropsWithChildren } from 'react';
import { LinkProps } from '../../../../types/HtmlProps';

export function DownloadFileLink({ children, ...props }: PropsWithChildren<LinkProps>) {
  return (
    <a {...props} className="download__file-link">
      {children}
    </a>
  );
}
